import {
  OFFER_RESPONSE_CODES,
  RENTALOBJECT_TYPE_CODES,
  WAITING_LIST_TYPES,
} from '@/config/constants';

import dayjs from 'dayjs';

export default {
  // props: {
  //   offer: {
  //     type: Object,
  //     required: false
  //   },
  //   offerNumber: {
  //     type: String,
  //     required: false
  //   }
  // },
  computed: {
    /**
     * Offernumber
     * Typ, 4003-009-03-0022-2-1
     */
    number() {
      if (this._offer) return this._offer.offerNumber;
    },

    /**
     * Datum och uppgifter för visning.
     *
     * Typ. [displayTime: '2018....', name:'Kalle', email:'kall@anka.se', phone:'123123' .... ]
     */
    displayTimes() {
      if (this._offer) return this._offer.displayTimes;

      return [];
    },

    /**
     * Returnar rentalObject objektet
     */
    rentalObject() {
      if (this._offer) return this._offer.rentalObject;
    },

    /**
     * Typ, 3108-001-02-0031
     */
    rentalObjectCode() {
      if (this._offer) return this._offer.rentalObjectCode;
    },

    /**
     * Typ, LGH20
     */
    rentalObjectTypeCode() {
      if (this._offer) return this._offer.rentalObject.rentalObjectTypeCode;
    },

    /**
     * Inflyttningsdatum
     */
    vacantFrom() {
      if (this._offer) return this._offer.vacantFrom;
    },

    /**
     * Inflyttningsdatum. t.ex. 2018-12-15 eller idag
     */
    vacantFromText() {
      if (!this._offer || !this._offer.vacantFrom) return;

      const formatedDate = dayjs(this._offer.vacantFrom).format('YYYY-MM-DD');

      if (dayjs(formatedDate).isBefore()) return 'Omgående';

      return formatedDate;
    },

    /**
     * Sista svarsdatumet
     */
    lastReplyDate() {
      if (this._offer) return this._offer.lastReplyDate;
    },

    /**
     * Vilket datum man svarade på erbjudandent
     */
    replyDate() {
      if (this._offer && this._offer.replyDate) return this._offer.replyDate;

      return null;
    },

    /**
     * Har LastReply passerat?
     */
    lastReplyHasPast() {
      if (!this._offer || !this._offer.lastReplyDate) return false;

      return dayjs(this._offer.lastReplyDate).isBefore();
    },

    status() {
      return 'handläggs';
    },

    /**
     * Får man svara på erbjudandet?
     */
    answerIsReplyable() {
      if (!this._offer) return false;

      // Sista svarsdatum får ej passerat
      if (this.lastReplyHasPast) return false;

      // Man får inte redan ha svarat Nej
      if (this._offer.responseCode === OFFER_RESPONSE_CODES.NO) return false;

      // Studentbostäder får inte ändra svar ens om dom svarat Ja
      if (
        this.rentalObjectTypeCode == RENTALOBJECT_TYPE_CODES.STUDENTBOSTAD &&
        this._offer.responseCode === OFFER_RESPONSE_CODES.YES
      )
        return false;

      return true;
    },

    /**
     * Har man svarat på erbjudandet?
     */
    hasAnswered() {
      if (this._offer)
        return (
          this._offer.responseCode == OFFER_RESPONSE_CODES.YES ||
          this._offer.responseCode == OFFER_RESPONSE_CODES.NO
        );
    },

    /**
     * Vilket svar man gett.
     * Typ: JA, NEJ eller EJ SVAR
     */
    responseCode() {
      if (this._offer) return this._offer.responseCode;
    },

    /**
     * Antal som tackat ja till detta erbjudanden, förutom mig
     */
    numberOfApplicationsBefore() {
      if (this._offer) return this._offer.numberOfApplicationsBefore;
    },

    /**
     * Min plats i kö
     */
    order() {
      /**
       * Bostäder som ligger under "Marknadsplats Ungdomskampanj" slumpas fram. Man har alltså ingen köplats.
       */
      if (
        this._offer.rentalObject &&
        this._offer.rentalObject.waitingListType === WAITING_LIST_TYPES.UNGDOMSKAMPANJ
      )
        return;

      if (this._offer) return this._offer.order;
    },

    /**
     * Typ "premise", "apartment"
     */
    objectType() {
      if (this._offer) return this._offer._objectType;
    },
  },
};
